// ADD YOUR OWN GOOGLE MAPS API KEY HERE
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDNzEPktSJStYeiy7uBMKDPQrGaKTLlYnc'
